// extracted by mini-css-extract-plugin
export var wrapper = "News-module--wrapper--2_-Ow";
export var more = "News-module--more--zUZ_U";
export var itemGrid = "News-module--itemGrid--JpEVv";
export var item = "News-module--item--3u2uH";
export var imgbox = "News-module--imgbox--afsUO";